import { t } from "@travily/i18n";
import type { ProgramFormat } from "@travily/types/models";
import { Icon } from "@ui/components/Icon";
import { ToggleTile } from "@ui/components/ToggleTile";
import { FORMAT_OPTIONS } from "../constants";

export interface ProgramsFormatFilterProps {
  onToggle: (value: ProgramFormat) => void;
  selected: string[];
}

export function ProgramsFormatFilter({ onToggle, selected }: ProgramsFormatFilterProps) {
  const selectedSet = new Set(selected);

  return (
    <div className="grid grid-cols-2 gap-4">
      {FORMAT_OPTIONS.map((option) => (
        <ToggleTile
          color={option.color}
          icon={<Icon color={option.color} name={option.icon} type="sticker" />}
          isSelected={selectedSet.has(option.value)}
          key={option.value}
          label={t(option.labelKey)}
          onChange={() => onToggle(option.value)}
          orientation="horizontal"
        />
      ))}
    </div>
  );
}
